<template>
    <div class="appnewsdetail">
      <div class="container row">
        <router-link to='/news' class="gobacklink"><img :src="back_arrow" /> Latest News</router-link>
      </div>
      <div class="container row">
        <div class="col-md-9">
          <div class="event_title">
            <p>{{ post_time }}</p>
            <h4>{{ news.post_title }}</h4>
          </div>
          <div class="event_detail">
            <img :src="news.featured_image" class="detail_image" />
            <p v-html="news.post_content"></p>
          </div>
        </div>
        <div class="col-md-3">
          <div class="author_part">
            <img :src="this.author_data.avatar" />
            <div class="author_info">
              <h5>Published by</h5>
              <h3>{{this.author_data.first_name}} {{this.author_data.last_name}}</h3>
            </div>
          </div>
          <h4 class="share">Share this point</h4>
          <div class="iconpart">
            <div class="social-icon"><font-awesome-icon :icon="['fab', 'facebook-f']" :style="{color: '#fff'}" /></div>
            <div class="social-icon"><font-awesome-icon :icon="['fab', 'twitter']" :style="{color: '#fff'}" /></div>
          </div>
        </div>
        <div class="likepart">
          <h3>You may also like:</h3>
          <div class="row">
            <div v-for="news in news_array" v-bind:key="news.id" class="post col-md-4">
                <img :src="news.image" class="post_image" />
                <div class="post_info">
                    <div class="post_date">{{news.post_time}}</div>
                    <div class="post_desc">{{news.post_title}}</div>
                    <router-link :to="news.link" class="readmore">Read Story</router-link>
                </div>
            </div>
          </div>
        </div>
      </div>
    </div>
</template>

<script>
export default {
  data () {
    return {
      wpData: wpData,
      news_array: [],
      news: {},
      author_data: {},
      post_time: '',
      back_arrow: '',
    }
  },
  mounted() {
    this.back_arrow = this.wpData.template_directory_uri + "/spa/assets/images/back-arrow.png";
    this.featured_image = this.wpData.template_directory_uri + "/spa/assets/images/gettyimages-1062184734-170667a.jpg";
    this.news = this.wpData.pcgnews.filter(post=>post.ID == this.$route.params.id)[0];
    fetch(`${this.wpData.rest_url}/wp/v2/author/${this.news.post_author}`)
      .then(res => res.json())
      .then(data => {this.author_data = data;});
    var months = ["January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December"];
    var post_date = new Date(this.news.post_date);
    this.post_time = months[parseInt(post_date.getMonth())] + " " + post_date.getDate() + ", " + post_date.getFullYear();
    var j = 0;
    for(var i = 0; i < this.wpData.pcgnews.length; i++){
      if(j < 3 && this.wpData.pcgnews[i].ID != parseInt(this.$route.params.id)){
        var post_date1 = new Date(this.wpData.pcgnews[i].post_date);
        var news = {id: this.wpData.pcgnews[i].ID, image: this.wpData.pcgnews[i].featured_image, post_time: months[parseInt(post_date1.getMonth())] + " " + post_date1.getDate() + ", " + post_date1.getFullYear(), post_title: this.wpData.pcgnews[i].post_title, post_desc: this.wpData.pcgnews[i].post_content, link: "/news/"+this.wpData.pcgnews[i].ID}
        j++;
        this.news_array.push(news);
      }
    }
    this.post_author_img = this.wpData.template_directory_uri + "/spa/assets/images/portrait1BW.png";
  },
  watch: {
    '$route' (to, from) {
      this.$router.go(to.path);
    }
  },
  methods: {
    gotoMenuPage: function(event){
      alert("Event1");
    }
  }
}
</script>

<style>
.appnewsdetail {
  position: relative;
  width: 100%;
  min-height: calc(100vh - 100px);
  padding: 50px 0;
  background: #fff;
  color: #172c62;
}
.appnewsdetail .container{
  opacity: 0;
  animation-duration: 2s;
  animation-name: fade;
  animation-fill-mode: forwards;
  margin: auto;
}
.gobacklink{
  margin-left: 15px;
  margin-bottom: 20px;
  color: #172c62;
  font-size: 22px;
}
.gobacklink:hover{
  text-decoration: none;
}
.gobacklink img{
  margin-right: 5px;
}
.appnewsdetail .container .event_title{
  text-align: left;
  font-family: brandingsemibold;
  margin-bottom: 20px;
}
.appnewsdetail .container .event_title h3{
  font-size: 30px;
}
.appnewsdetail .container .event_title h4{
  font-size: 24px;
  margin: 0;
  padding: 0;
}
.appnewsdetail .container .event_detail img{
  width: 360px;
  margin-right: 20px;
  float: left;
}
.appnewsdetail .container .event_detail p{
  font-size: 16px;
  font-size: 16px;
  text-align: left;
}
.author_part img{
  float: left;
  width: 35%;
}
.author_info{
  width: 60%;
  float: right;
  text-align: left;
}
.author_info h5{
  font-size: 15px;
}
.author_info h3{
  font-family: brandingsemibold;
  font-size: 21px;
  padding-top: 0;
}
.appnewsdetail h4.share{
  font-size: 16px;
  text-align: left;
}
.appnewsdetail .likepart{
  margin-top: 100px;
}
.appnewsdetail .likepart h3{
  font-size: 25px;
  text-align: left;
  margin-left: 15px;
  margin-bottom: 20px;
}
.appnewsdetail .likepart .post{
    position: relative;
    margin-bottom: 50px;
}
.appnewsdetail .likepart .post img{
    width: 100%;
}
.appnewsdetail .likepart .post .post_info{
    text-align: left;
    position: absolute;
    width: calc(100% - 60px);
    bottom: 10px;
    left: 30px;
    background: rgba(23, 44, 98, 0.9);
    padding: 5px 10px;
    color: #fff;
}
.appnewsdetail .likepart .post .post_info .post_date{
    font-size:9px;
    margin-bottom: 5px;
}
.appnewsdetail .likepart .post .post_info .post_desc{
    font-size: 11px;
    font-family: brandingsemibold;
    line-height: 11px;
}
.appnewsdetail .likepart .post .post_info .readmore{
  width: 80px;
  height: 18px;
  font-size: 9px;
  padding: 0;
  background: none;
  color: #ffffff;
  border: 1px solid #ffffff;
  display: flex;
  justify-content: center;
  align-items: center;
  margin-top: 10px;
  text-decoration: none;
  float: right;
  transition: all 0.2s ease-in-out;
}
.appnewsdetail .likepart .post .post_info .readmore:hover{
  background:#ffffff;
  color: #2E55A5;
}
.appnewsdetail .iconpart{
  display: flex;
  margin-top: 10px;
}
.appnewsdetail .social-icon{
  background: #172C62;
  margin-right: 12px;
}
@keyframes fade {
  from {
    opacity: 0;
  }

  to {
    opacity: 1;
  }
}
</style>


// WEBPACK FOOTER //
// src/components/AppNewsDetail.vue